import React from 'react';
import AppDispatcher from './../dispatcher/AppDispatcher';
import AppConstants from './../constants/AppConstants';
import MainMenuStore from './../stores/MainMenuStore';
import MenuButton from './MenuButton.jsx';


const Menu = React.createClass({
  /**
   * Used by React as the component name
   */
  displayName: 'Menu',


  /**
   * Expected propTypes
   * @prop {Number} currentSlide - The iteration of the current section
   * @prop {Object} data - A data object
   * @prop {Boolean} large - If the user is viewing the large experience
   * @prop {Boolean} touch - If browser supports touch events
   */
  propTypes: {
    currentSlide: React.PropTypes.number,
    data: React.PropTypes.array.isRequired,
    large: React.PropTypes.bool.isRequired,
    touch: React.PropTypes.bool,
  },


  /**
   * Called after component mounts to DOM
   * @returns {undefined} undefined
   */
  componentDidMount() {
    MainMenuStore.addChangeListener(this._onChange);
  },


  /**
   * Called before component is removed from the DOM
   * @returns {undefined} undefined
   */
  componentWillUnmount() {
    MainMenuStore.removeChangeListener(this._onChange);
  },


  /**
   * Get initial state object
   * @returns {Object} initial state
   */
  getInitialState() {
    return {
      dragging: false,
    };
  },


  /**
   * Renders component
   * @returns {Object} React element
   */
  render() {
    const draggingClass = this.state.dragging ? ' dragging' : '';
    const openClass = this.state.menuOpen ? ' open' : '';
    const className = 'component-menu' +
      draggingClass +
      openClass;
    const menuButtons = this._renderMenuButtons();

    return (
      <div className={className}>
        <div className='sep' />
        <div ref='buttonWrapper' className='button-wrapper'>
          <ul className='buttons'>
            {menuButtons}
          </ul>
        </div>
      </div>
    );
  },


  /**
   * Renders buttons
   * @returns {Array<ReactElements>} An array of React elements
   */
  _renderMenuButtons() {
    const buttons = [];
    const data = this.props.data;

    for (let i = 0; i < data.length; i++) {
      const key = 'menu-button-' + i;

      if (data[i].type !== 'credits' &&
        data[i].type !== 'landing' &&
        data[i].type !== 'description') {
        buttons.push(
          <MenuButton
            buttonWrapperEl={this.refs.buttonWrapper}
            iteration={i}
            currentSlide={this.props.currentSlide}
            data={data[i]}
            key={key}
            large={this.props.large}
          />
        );
      }
    }

    return buttons;
  },


  /**
   * Closes the menu
   * @returns {undefined} undefined
   */
  _closeMenu() {
    AppDispatcher.handleViewAction({
      actionType: AppConstants.CLOSE_MAIN_MENU,
    });
  },


  /**
   * Called when a CHANGE event is emitted from the MainMenuStore
   * @returns {undefined} undefined
   */
  _onChange() {
    this.setState(MainMenuStore.getState());
  },
});

export default Menu;



/** WEBPACK FOOTER **
 ** ./assets/js/src/components/Menu.jsx
 **/